/* Hand selector for linked left/right-hand products (#24). See snippets/DG-hand-switcher.liquid. */
(() => {
  const root = document.querySelector('[data-dg-hand]');
  if (!root) return;

  const native = document.getElementById('dg-hand-native');
  const titles = document.querySelectorAll('[data-dg-full-title]');
  const error = root.querySelector('[data-dg-hand-error]');
  const current = root.dataset.currentUrl;
  const SCROLL_KEY = 'dg-hand-scroll';
  let chosen = false;

  const choose = () => {
    chosen = true;
    root.dataset.chosen = 'true';
    titles.forEach((title) => { title.textContent = title.dataset.dgFullTitle; });
    if (error) error.hidden = true;
    // Add to cart waits for a hand like any other option (data-chosen), so re-check it now.
    document.querySelector('custom-product-attributes')?.updateAddToCartButton?.();
  };

  // custom-select fires 'change' on its native <select> when it has one, otherwise on itself
  // (detail.selectedValue); both bubble to root.
  root.addEventListener('change', (event) => {
    const value = (event.detail && event.detail.selectedValue) || (native && native.value) || '';
    if (!value) return;
    if (value === current) {
      choose();
      return;
    }
    const next = new URL(value, window.location.origin);
    next.searchParams.set('hand', '1');
    const picked = readAttributes();
    if (picked.length) next.searchParams.set('attrs', JSON.stringify(picked));
    // The other hand's page opens with this selector where it is now on screen, not at the top.
    try {
      sessionStorage.setItem(SCROLL_KEY, JSON.stringify({ path: next.pathname, top: root.getBoundingClientRect().top }));
    } catch (e) { /* storage blocked: the page just opens at the top */ }
    window.location.href = next.toString();
  });

  function restoreScroll() {
    let saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(SCROLL_KEY));
      sessionStorage.removeItem(SCROLL_KEY);
    } catch (e) {
      saved = null;
    }
    if (!saved || saved.path !== window.location.pathname || typeof saved.top !== 'number') return;

    // The header and late images keep shifting the layout until shortly after load, so the selector
    // is held in place each frame until then. Any input from the shopper hands scrolling back.
    const stopEvents = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    const start = performance.now();
    let loadedAt = document.readyState === 'complete' ? start : 0;
    let holding = true;
    const stop = () => {
      holding = false;
      stopEvents.forEach((type) => window.removeEventListener(type, stop));
    };
    stopEvents.forEach((type) => window.addEventListener(type, stop, { passive: true }));
    window.addEventListener('load', () => { loadedAt = performance.now(); }, { once: true });

    const hold = () => {
      if (!holding) return;
      const shift = root.getBoundingClientRect().top - saved.top;
      if (Math.abs(shift) > 1) window.scrollTo({ top: window.scrollY + shift, behavior: 'instant' });
      const now = performance.now();
      if ((loadedAt && now - loadedAt > 500) || now - start > 6000) stop();
      else requestAnimationFrame(hold);
    };
    hold();
  }

  const attributes = document.querySelector('custom-product-attributes');
  const selectorsOf = () => (attributes ? [...attributes.querySelectorAll('.option-selector')].filter((el) => !el.closest('[hidden]')) : []);
  const nameOf = (selector) => (selector.dataset.selectorType === 'loft-grid'
    ? selector.dataset.property
    : selector.querySelector('legend, label')?.textContent.trim());

  // [name, value] per chosen attribute. The loft grid's value is the list of pressed lofts, plus
  // their display names, in case the other hand lacks one.
  function readAttributes() {
    return selectorsOf().map((selector) => {
      const type = selector.dataset.selectorType;
      if (type === 'loft-grid') {
        const pressed = [...selector.querySelectorAll('[data-loft][aria-pressed="true"]')];
        const names = Object.fromEntries(pressed.map((b) => [b.dataset.loft, b.closest('li')?.querySelector('.DG-loft-grid__name')?.textContent.trim()]));
        return [nameOf(selector), pressed.map((b) => b.dataset.loft), names];
      }
      const picked = type === 'dropdown'
        ? selector.querySelector('select')?.value || ''
        : selector.querySelector('input[type="radio"]:checked')?.value || '';
      return [nameOf(selector), picked];
    }).filter(([name, picked]) => name && picked.length);
  }

  const unavailableText = root.dataset.strUnavailable || 'Unavailable';

  // Shows the carried value as the picked option, labelled unavailable. The native <select> stays
  // empty, so Add to cart stays disabled until a real option is picked. It stays in the list but
  // can't be picked again.
  function showUnavailableOption(selector, select, value) {
    const option = document.createElement('li');
    option.className = 'custom-select__option js-option is-disabled';
    option.id = `${select.id}-opt-unavailable`;
    option.setAttribute('role', 'option');
    option.setAttribute('aria-disabled', 'true');
    option.dataset.value = '';
    const label = document.createElement('span');
    label.className = 'pointer-events-none';
    label.textContent = `${value} - ${unavailableText}`;
    option.append(label);
    const listbox = selector.querySelector('[role="listbox"]');
    const blank = listbox.querySelector('[data-value=""]');
    if (blank) blank.after(option);
    else listbox.prepend(option);
    select.selectOption(option);
    option.addEventListener('click', (event) => event.stopPropagation());
  }

  // A row per carried loft this hand doesn't offer. No data-loft, so Select all, the count and the
  // subtotal leave it out.
  function showUnavailableLofts(selector, lofts, names) {
    const list = selector.querySelector('.DG-loft-grid__list');
    lofts.forEach((loft) => {
      const row = document.createElement('li');
      row.className = 'DG-loft-grid__row DG-loft-grid__row--unavailable';
      const name = document.createElement('span');
      name.className = 'DG-loft-grid__name';
      name.textContent = names[loft] || loft;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'DG-loft-grid__btn';
      button.disabled = true;
      button.textContent = unavailableText;
      row.append(name, button);
      list.append(row);
    });
  }

  // Re-picks each carried value this product also offers, through the controls' own handlers.
  function restoreAttributes(picked) {
    const wanted = new Map(picked.map(([name, value]) => [name, value]));
    const loftNames = new Map(picked.map(([name, , names]) => [name, names || {}]));
    selectorsOf().forEach((selector) => {
      const value = wanted.get(nameOf(selector));
      if (!value) return;
      const type = selector.dataset.selectorType;
      if (type === 'loft-grid') {
        if (!Array.isArray(value)) return;
        const buttons = [...selector.querySelectorAll('[data-loft]')];
        buttons.forEach((button) => {
          if (value.includes(button.dataset.loft) !== (button.getAttribute('aria-pressed') === 'true')) button.click();
        });
        const missing = value.filter((loft) => !buttons.some((button) => button.dataset.loft === loft));
        if (missing.length) showUnavailableLofts(selector, missing, loftNames.get(nameOf(selector)));
      } else if (type === 'dropdown') {
        const select = selector.querySelector('custom-select');
        if (typeof select?.selectOption !== 'function') return;
        // custom-select links its native <select> in a lazy init; until then selectOption only relabels.
        select.nativeSelect = select.nativeSelect || document.getElementById(`${select.id}-native`);
        const option = [...selector.querySelectorAll('[role="option"]')].find((el) => el.dataset.value === value);
        if (option) select.selectOption(option);
        else showUnavailableOption(selector, select, value);
      } else {
        const radio = [...selector.querySelectorAll('input[type="radio"]')].find((el) => el.value === value);
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  const carried = new URLSearchParams(window.location.search).get('attrs');
  if (carried && attributes) {
    let picked = [];
    try { picked = JSON.parse(carried); } catch (e) { picked = []; }
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('attrs');
    window.history.replaceState(window.history.state, '', cleanUrl.toString());
    // The attribute element wires its listeners once it has found the product form.
    Promise.all([customElements.whenDefined('custom-select'), customElements.whenDefined('custom-product-attributes')]).then(() => {
      const waitForForm = (tries = 0) => {
        if (attributes.form) restoreAttributes(Array.isArray(picked) ? picked : []);
        else if (tries < 120) requestAnimationFrame(() => waitForForm(tries + 1));
      };
      waitForForm();
    });
  }

  // Arrived by picking this hand on the other product: select it straight away.
  if (new URLSearchParams(window.location.search).has('hand')) {
    restoreScroll();
    customElements.whenDefined('custom-select').then(() => {
      const select = root.querySelector('custom-select');
      const option = [...root.querySelectorAll('[role="option"]')].find((el) => el.dataset.value === current);
      if (select && option && typeof select.selectOption === 'function') {
        select.nativeSelect = select.nativeSelect || native;
        select.selectOption(option);
      } else {
        choose();
      }
    });
  }

  // On document, so it runs before the form's own capture listeners (product-form's multi-add).
  document.addEventListener('submit', (event) => {
    // getAttribute: the form's `id` property is shadowed by its <input name="id">.
    if (chosen || event.target.getAttribute('id') !== root.dataset.formId) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (error) error.hidden = false;
    root.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);
})();
